import React from 'react';
import {LearningObjectiveTextInput} from './LearningObjectiveTextInput';

export const LearningObjectiveWithInfoTextInput = () => {
  return <LearningObjectiveTextInput infoText="For multiple learning objectives use a semicolon." />;
};
